export default __webpack_public_path__ + "static/project-slide-3-1640-765-3f88fda04b0ca5d40f5234fda9babc98.webp";